<template>
<div class="chapter">
<div class="inner_page">
<p class="pn" id="pt1"><span class="epub-b">PART 1</span></p>
<p class="pt"><span class="epub-b">High Summer</span></p>
<p class="pep">Now is the winter of our discontent</p>
<p class="pep-bot">Made glorious summer by this sun of York.</p>
<p class="pepc">—Shakespeare, <span class="epub-i">Richard III</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?5cd2552c